module.exports = __webpack_public_path__ + "img/alarm-clock-off.d34c445e.svg";